export namespace Entity {
  export class Coupon {
    id: number
    name: string
    benefitType:
      | 'DELIVERY_DISCOUNT'
      | 'PRODUCT_DISCOUNT'
      | 'PRODUCT_FREE'
      | 'PRODUCT_PERCENT_DISCOUNT'
    benefitName: string
    conditionName: string
    benefitValue: number
    endDate: string
    discountAmount?: number
    usable?: boolean
    usageStatus?: 'UNREGISTERED' | 'UNUSED' | 'USED'

    constructor(props: Coupon) {
      this.id = props.id
      this.name = props.name
      this.benefitType = props.benefitType
      this.benefitValue = props.benefitValue
      this.benefitName = props.benefitName
      this.conditionName = props.conditionName
      this.endDate = props.endDate
      this.discountAmount = props.discountAmount
      this.usable = props.usable
      this.usageStatus = props.usageStatus
    }
  }
}
